// import { useSelector } from "react-redux";
// import SyIcon from "../../../../shared/components/sy-icon";
// import { SHAREDETAILS } from "./config";
// import styles from "./style.module.scss";
// import { getImageDetails } from "../../../../feature/image-slice";

// const SharePop = (props: any) => {
//   const { onClose } = props;
//   const imageDetails = useSelector(getImageDetails);

//   const onClickClose = (val: boolean = false) => {
//     onClose(val);
//   };

//   const handleShareClick = (type: string) => {
//     const pageUrl = window.location.href;

//     switch (type) {
//       case "whatsapp":
//         openWhatsapp(pageUrl);
//         break;

//       case "facebook":
//         openFacebook(pageUrl);
//         break;

//       case "instagram":
//         openInstagram(pageUrl);
//         break;

//       case "twitter":
//         openX(pageUrl);
//         break;

//       case "communication":
//         openSlack(pageUrl);
//         break;

//       default:
//         navigator.clipboard.writeText(pageUrl);
//     }
//   };

//   const openWhatsapp = (pageUrl: any) => {
//     window.open(`https://wa.me/?text=${encodeURIComponent(pageUrl)}`, "_blank");
//   };

//   const openFacebook = (pageUrl: any) => {
//     window.open(
//       `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
//         pageUrl
//       )}`,
//       "_blank"
//     );
//   };

//   const openSlack = (pageUrl: string) => {
//     const encodedText = encodeURIComponent(pageUrl);
//     navigator.clipboard.writeText(pageUrl);
//     window.location.href = `slack://open?message=${encodedText}`;
//     setTimeout(() => {
//       window.open(
//         `https://slack.com/intl/en-in/share?url=${encodedText}`,
//         "_blank"
//       );
//     }, 500);
//   };

//   const openInstagram = (pageUrl: string) => {
//     // Instagram does NOT allow direct web sharing
//     // Best UX: copy link & inform user
//     navigator.clipboard.writeText(pageUrl);
//     alert("Link copied! Paste it into Instagram.");
//   };

//   const openX = (pageUrl: string) => {
//     window.open(
//       `https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}`,
//       "_blank"
//     );
//   };

//   return (
//     <div className="rounded-4 p-3 w-100 pop-bg">
//       <div className="d-flex align-items-center justify-content-between pb-3">
//         <h2 className="mohave m-0 title-font">Share</h2>

//         <SyIcon
//           name="close"
//           iconType="symbols"
//           iconStyle="outlined"
//           iconColor="white"
//           className="pointer"
//           onClick={onClickClose}
//         />
//       </div>
//       <div className="d-flex justify-content-between my-3 pointer mx-3">
//         {imageDetails.share.map((share: any, i: number) => (
//           <div>
//             <img
//               src={share.img}
//               className={styles.img}
//               onClick={() => handleShareClick(share.name)}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default SharePop;

import {
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  EmailShareButton,
  WhatsappIcon,
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  EmailIcon,
} from "react-share";
import SyIcon from "../../../../shared/components/sy-icon";
import { useState } from "react";

const SharePop = ({ onClose, planetData }: any) => {
  const shareUrl = window.location.href;
  const [copied, setCopied] = useState(false);
  // const title = planetData.pro_name;
  // const description = planetData.pro_sub || planetData.pro_desc;
  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2s
    });
  };
  return (
    <div className="p-4 pop-bg">
      <div className="d-flex justify-content-between align-items-center mb-3 ">
        <h2 className="mohave m-0 title-font">Share</h2>
        <SyIcon name="close" className="pointer" onClick={onClose} />
      </div>
      <div className="d-flex gap-2 align-items-center mt-3">
        <input
          type="text"
          value={shareUrl}
          readOnly
          className="form-control form-control-sm" // smaller input
          style={{ flex: 1, fontSize: "0.85rem", padding: "0.25rem 0.5rem" }}
        />
        <button
          className="btn btn-primary btn-sm" // smaller button
          onClick={handleCopy}
          style={{ fontSize: "0.85rem", padding: "0.25rem 0.5rem" }}
        >
          {copied ? "Copied!" : "Copy"}
        </button>
      </div>

      <div className="d-flex gap-3 flex-wrap mt-4">
        <WhatsappShareButton url={shareUrl}>
          <WhatsappIcon size={48} round />
        </WhatsappShareButton>

        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={48} round />
        </FacebookShareButton>

        <TwitterShareButton url={shareUrl}>
          <TwitterIcon size={48} round />
        </TwitterShareButton>

        <TelegramShareButton url={shareUrl}>
          <TelegramIcon size={48} round />
        </TelegramShareButton>

        <EmailShareButton url={shareUrl}>
          <EmailIcon size={48} round />
        </EmailShareButton>
      </div>
    </div>
  );
};

export default SharePop;
